<template>
  <div class="bulidPlan">
    <div class="mainHeader">计划</div>
    <div class="header">
      <el-button size="small" type="primary" @click="addPlanHandler">新建计划</el-button>
      <el-input v-model="search" placeholder="请输入计划名称" size="small" @input="getTableData(1)" clearable></el-input>
    </div>
    <div class="content">
      <el-table v-loading="loading" :data="plantable" :row-style="rowStyle" :header-cell-style="headerStyle"
        element-loading-text="数据加载中" height="100%" @row-click="rowClick" >
        <template slot="empty">
          <img :src="zanwu" alt="暂无数据" />
          <p >暂无数据</p>
        </template>
        <el-table-column label="计划名称"  prop="conPlanName" align="center"/>
        <!-- <el-table-column label="关联BIM4D方案" align="left"  prop="programms" show-overflow-tooltip/> -->
        <el-table-column label="计划编制人" prop="planUserName" />
        <el-table-column label="创建时间"  prop="conPlanCreateDate" />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button :disabled='row.isHomePageShow==1' type="text" class="operBtn" @click.stop="setUpData(row)">显示主页</el-button>
            <el-button type="text" class="operBtn" @click.stop="editorData(row)">重命名</el-button>
            <el-button type="text" class="operBtn" @click.stop="deleteData(row)">删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="getTableData" ></page>
    </div>
  </div>
</template>

<script>
import bimService from "@/xgzdService/buildPlan-service"
import page from '@/CommonDP/components/paging'
import { mapState } from 'vuex'
export default {
  components: { page },
  data(){
    return{
      search:"",
      plantable:[ ],
      loading:false,
      zanwu: require('@/CommonDP/assets/暂无数据.png'),
      page: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0
      }
    }
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
    })
  },
  created() {
    this.getTableData(1)
  },
  methods:{
    async getTableData(index) {
      this.loading = true
      const { search, enterpriseId, page: { pageSize },prjInfo:{prjId} } = this;
      const params = {
        conPlanName: search,
        pageSize,
        pageNum: index,
        enterpriseId,
        prjId
      }
      const { data, totalCount, pageNum } = await bimService.getConstructionPlan(params)
      this.page.totalCount = totalCount
      this.page.pageNum = pageNum
      this.plantable = data
      this.loading = false
    },
    // 添加计划
    addPlanHandler() {
      const{prjInfo:{prjId},enterpriseId,page:{pageSize,pageNum}}=this;
      this.$prompt('请输入计划名称', '添加计划', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入计划名称',
        inputErrorMessage: '请输入首尾不为空格,且总长度大不大于15的计划名称',
        inputPattern: /^\S(.{0,13}\S)?$/,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'confirm') {
            try {
              const params={
                conPlanName:inputValue,
                prjId,
                enterpriseId,
              }
              await bimService.addConstructionPlan(params);
              await this.$message({ type: 'success', message: '计划添加成功' });
              await this.getTableData(1);
              done();
            } catch (e) {
              this.$message({ type: 'error', message: '计划添加失败' });
            }
          } else {
            done();
          }
        },
      });
    },
   editorData(row){
      this.$prompt('请输入计划名称', '编辑计划名称', {
        inputPlaceholder: '编辑计划名称',
        inputValue: row.conPlanName,
        inputErrorMessage: '请输入首尾不为空格,且总长度大不大于15的计划名称',
        inputPattern: /^\S(.{0,13}\S)?$/,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'cancel') done();
          else {
            try {
              await bimService.editConstructionPlan(inputValue,row.conPlanId);
              await this.$message({ type: 'success', message: '计划编辑成功' });
              await  this.getTableData(1);
              done();
            } catch (e) {
              this.$message({ type: 'error', message: '计划编辑失败' });
            }
          }
        },
      });
    },
    deleteData(row){
      if(row.programms){
        this.$message.warning("当前计划已关联方案，无法删除");
        return
      }
      this.$confirm(`确定删除计划名称 ${row.conPlanName}?`, '警告', { type: 'warning', })
      .then(() => bimService.delConstructionPlan(row.conPlanId))
      .then(() => { this.$message({ type: 'success', message: '删除计划成功' }) })
      .then(() => { this.getTableData(1) });
    },
    rowClick(row){
      this.$router.push({name:"buildTask",query:{conPlanId:row.conPlanId,conPlanName:row.conPlanName}})
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getTableData(1)
    },
    async setUpData(row){
      const { prjInfo:{prjId} } = this;
      this.$confirm(`确定设置 ${row.conPlanName} 为显示主页?`, '警告', { type: 'warning', })
      .then( async ()=> await bimService.updatePlanIsHomePageShow(row.conPlanId,prjId))
      .then(()=>{
        this.$message({ type: 'success', message: '设置成功' })
        this.getTableData(1)
      })
    },
    rowStyle() {
      return 'height:60px'
    },
    headerStyle() {
      return 'background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table .cell {
  white-space: pre;
}
.bulidPlan{
  width: 100%;
  height: 100%;
  background :#fff;
  position: relative;
  .mainHeader {
    width: 100%;
    height: 50px;
    padding-left: 30px;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 30px;
    .el-input{
      width: 200px;
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }
  .content {
    position: absolute;
    top: 105px;
    left: 30px;
    right: 30px;
    bottom: 40px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px;
  }
}
</style>